import { tryOnDestroy } from "../../shared";
export function eventListenerStore(eventName, handler, element, options) {
    // Create event listener that calls handler function stored in ref
    const listener = (event) => handler(event);
    function start() {
        const targetElement = element ?? window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        targetElement && targetElement.addEventListener(eventName, listener, options);
    }
    function stop() {
        const targetElement = element ?? window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        targetElement.removeEventListener(eventName, listener, options);
    }
    start();
    tryOnDestroy(stop);
    return { start, stop };
}
